export enum Column {
  SUBJECT,
  SENDER,
  RECIPIENTS,
  REAL_RECIPIENTS,
  STATUS,
  MALWARE_NAME,
  SERVER_NAME,
  COMPANY,
  QUARANTINED,
  ACTION_STATUS,
}

export enum ColumnKeys {
  SUBJECT = 'email.subject',
  SENDER = 'email.senderEmail',
  RECIPIENTS = 'email.recipients',
  REAL_RECIPIENTS = 'email.realRecipients',
  STATUS = 'threats.status',
  MALWARE_NAME = 'threats.name',
  SERVER_NAME = 'source.protectedEntity.name',
  COMPANY = 'source.company.name',
  QUARANTINED = 'quarantinedDate',
  ACTION_STATUS = 'actionStatus',
}
